import React from 'react'
import { Row, Col } from 'react-bootstrap'

const Item = ({
    children,
    onClick,
    active
}) => {
    const colStyle = {
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        marginLeft: '10px',
        marginRight: '25px',
        color: 'rgb(38, 153, 231)'
    }

    return (
        <Row><Col onClick={onClick} style={colStyle}>
            <input type="checkbox" checked={active} onChange={onClick} />
            <span style={{ paddingLeft: '10px', whiteSpace: 'nowrap', paddingTop: '3px'}} onClick={onClick}>{children}</span>
        </Col></Row>
    )
}

export default Item